const next = document.querySelector('#collection-slider-next');
const previous = document.querySelector('#collection-slider-previous');
const slider = document.querySelector('.collection-slider__list');

next.addEventListener('click', () => handleClick('next'));
previous.addEventListener('click', () => handleClick('previous'));
slider.addEventListener('scroll', () => onScroll());

onScroll();

function handleClick(direction) {
    const width = slider.offsetWidth;
    const scrollAmount = direction === 'next' ? width : -width;

    slider.scrollBy(scrollAmount, 0);
}
// Sets the visibility of the next and previous buttons
function onScroll() {
    const width = slider.offsetWidth;
    const scrollLeft = slider.scrollLeft;
    const scrollRight = scrollLeft + width;

    if (scrollLeft === 0) {
        previous.classList.add('hidden');
    } else {
        previous.classList.remove('hidden');
    }

    if (scrollRight === slider.scrollWidth) {
        next.classList.add('hidden');
    } else {
        next.classList.remove('hidden');
    }
}
